module.exports = __webpack_public_path__ + "media/images/tmp/fresh-0e0969a2eecd21f8d5bbae793b807e44.png";